const pillars = [
  {
    icon: 'ri-plant-line',
    label: 'Our Story',
    heading: 'Rooted in Responsible Trading',
    body:
      'We believe sustainable commodity trading is the cornerstone of a resilient global economy. By bridging markets responsibly, NRG Trading fosters long-term partnerships built on integrity, environmental awareness, and shared prosperity.',
  },
  {
    icon: 'ri-shield-check-line',
    label: 'Governance',
    heading: 'Global Standards, Local Commitment',
    body:
      'We operate in full alignment with international regulatory frameworks and industry best practices, ensuring every transaction upholds the highest levels of compliance, accountability, and institutional rigour.',
  },
  {
    icon: 'ri-compass-3-line',
    label: 'Purpose & Values',
    heading: 'Creating Value That Endures',
    body:
      'We measure success not only in margins, but in the lasting relationships we cultivate — driven by a culture that prizes candour, equitable dealing, and the quiet confidence that comes from doing things the right way.',
  },
];

export default function AboutUsSection() {
  return (
    <section className="bg-[#0c1f38] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="mb-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <p className="text-[#d4571a] text-xs font-semibold tracking-widest uppercase mb-3">
              Who We Are
            </p>
            <h2 className="text-white text-4xl font-bold leading-tight">
              About Us
            </h2>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed max-w-md">
            NRG Trading is built on three enduring foundations — a clear sense of history, a rigorous approach to governance, and an unwavering set of values that guide every decision we make.
          </p>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar) => (
            <div
              key={pillar.label}
              className="border border-white/10 rounded-lg p-8 flex flex-col gap-6 hover:border-[#d4571a]/40 transition-colors duration-300"
            >
              {/* Icon + Label */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#d4571a]/40 text-[#d4571a]">
                  <i className={`${pillar.icon} text-lg`} />
                </div>
                <span className="text-[#d4571a] text-xs font-semibold tracking-widest uppercase">
                  {pillar.label}
                </span>
              </div>

              {/* Divider */}
              <div className="w-10 h-px bg-[#d4571a]/30" />

              {/* Text */}
              <div>
                <h3 className="text-white text-xl font-bold mb-3 leading-snug">
                  {pillar.heading}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {pillar.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
